import { createRouter, createWebHashHistory } from 'vue-router'
import devView from '../views/devHome.vue'
import homeView from '../views/HomeView.vue'
import loginView from '../views/loginView.vue'
import OrderView from '../views/OrderView.vue'
import AgentView from '../views/AgentView.vue'
import AdminView from '../views/AdminView.vue'
import ResetPasswordView from '@/views/ResetPasswordView.vue'
import { useUserStore } from '@/stores/userStore.js'

const isLogged = (to, from, next)=>{
  if(useUserStore().logged){
    next()
  }
  else{
    next('/login');
  }
}

const isLoggedAndAdmin = (to, from, next)=>{
  if(useUserStore().logged && useUserStore().loggedRole>1){
    next()
  }
  else{
    next('/login');
  }
}


const routes = [
  {
    path: '/',
    name: 'home',
    component: homeView,
    beforeEnter:isLogged
  },
  {
    path: '/order',
    name: 'order',
    component: OrderView,
    beforeEnter:isLogged
  },
  {
    path: '/login',
    name: 'login',
    component: loginView
  },  
  {
    path: '/resetPassword/:token?',
    name: 'resetPassword',
    component: ResetPasswordView
  }, 
  {
    path: '/dev',
    name: 'dev',
    component: devView,
    beforeEnter:isLogged
  },  
  {
    path: '/agent',
    name: 'agent',
    component: AgentView,
    beforeEnter:isLogged
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    beforeEnter:isLoggedAndAdmin
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
